import React from 'react'
import styles from "./WarningModal.module.scss";
// import { X } from 'lucide-react';

interface WarningModalProps {
    message: string;
    onClose: () => void;
    title:string;
    onConfirm:()=>void
    loading?:boolean
}

const WarningModal = ({ message, onClose, title, onConfirm, loading }: WarningModalProps) => {
  return (
  <div className={`${styles.warningModal}`}>
    {/* <div className={`${styles.warningModal__close}`}><span role='button' onClick={onClose}>  <X /></span></div> */}
        <h2>{title}</h2>
        <p>{message}</p>
        <div className='flex justify-end gap-10'>
        <button disabled={loading} className='outline button sm' onClick={onClose}>Close</button>
        <button disabled={loading} className='button sm' onClick={onConfirm}>Confirm</button>
        </div>
    </div>
  )
}

export default WarningModal